<template>
  <div>
    <div class="input-title">{{ title }}</div>
    <div v-if="type == 'text'" class="input-containear" style="position: relative">
      <input
        :type="getInputType()"
        :style="getWarning()"
        v-mask="mask"
        @keyup.enter="returnValue()"
        v-model="inputValue"
        class="input-value"
        :placeholder="placeholder"
      />

      <span
        v-if="password"
        class="material-icons input-icon password-toggle"
        @click="showPassword = !showPassword"
      >
        {{ showPassword ? "visibility_off" : "visibility" }}
      </span>
      <span v-else-if="iconName" class="material-icons input-icon" @click="returnValue()">
        {{ iconName }}
      </span>
    </div>

    <div v-if="type == 'select'" :style="getWarning()" class="input-containear">
      <select v-model="selectValue" class="input-select-value">
        <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
        <option v-for="(x, idx) in list" :value="x.value" :key="idx">{{ x.text }}</option>
      </select>
    </div>
    <div v-if="type == 'disabled'" class="input-containear">
      <select
        style="cursor: not-allowed"
        disabled
        v-model="selectValue"
        class="input-select-value"
      >
        <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
        <option v-for="(x, idx) in list" :value="x.value" :key="idx">{{ x.text }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "StandardInput",
  props: [
    "title",
    "type",
    "list",
    "value",
    "action",
    "placeholder",
    "iconName",
    "auto",
    "password",
    "mask",
    "warning",
  ],
  data() {
    return {
      inputValue: "",
      selectValue: "",
      showPassword: false,
      syncingSelectValue: false,
    };
  },
  methods: {
    returnValue() {
      this.action(this.inputValue);
    },
    getWarning() {
      if (this.warning) return "border: 1px solid lightcoral";
    },
    getInputType() {
      if (this.password) {
        return this.showPassword ? "text" : "password";
      }
      return this.type;
    },
  },
  watch: {
    selectValue(newValue) {
      if (this.syncingSelectValue) {
        this.syncingSelectValue = false;
        return;
      }
      this.action(newValue);
    },
    inputValue(newValue) {
      if (this.auto) this.action(newValue);
    },
    value(newValue) {
      if (!newValue) {
        this.inputValue = undefined;
        this.syncingSelectValue = true;
        this.selectValue = undefined;
      }
      if (this.type == "text" && newValue) this.inputValue = newValue;
      if (this.type == "select" && newValue) {
        this.syncingSelectValue = true;
        this.selectValue = newValue;
      }
    },
  },
  mounted() {
    if (this.type == "text" && this.value) this.inputValue = this.value;
    if (this.type == "select" && this.value) {
      this.syncingSelectValue = true;
      this.selectValue = this.value;
    }
  },
};
</script>

<style scoped>
.input-title {
  font-weight: 400;
  font-size: 1.5em;
  letter-spacing: 0.15px;
  color: #6e6e6e;
}
.input-containear {
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1.5vh 0.7vw;
  display: flex;
  height: 6vh;
}
.input-value {
  border: none;
  flex: 1;
  font-weight: 400;
  font-size: 1.2em;
  letter-spacing: 0.15px;
  color: #6e6e6e;
  width: 100%;
}
.input-value:focus {
  border: none;
  outline: none;
}
.input-icon {
  color: #6e6e6e;
  cursor: pointer;
  font-size: 1.8em;
}
.input-select-value {
  border: none;
  font-weight: 400;
  font-size: 1.3em;
  letter-spacing: 0.15px;
  color: #6e6e6e;
  flex: 1;
  width: 5%;
}
.input-select-value:focus {
  border: none;
  outline: none;
}
.input-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
  font-size: 20px;
}

.password-toggle:hover {
  color: #333;
}


</style>
